module.exports = __webpack_public_path__ + "img/balkam-small.e1a01962.svg";